const LEVEL_MAP = {
    1: { label: 'Speculative' },
    2: { label: 'Emerging Narrative' },
    3: { label: 'Evidence-Based Claim' },
    4: { label: 'Mainstream Facts with Alternative Framing' },
    5: { label: 'Established Consensus or Ideology' },
};

// 1: { label: 'Very Low Confidence', tone: 'very-low' },
    // 2: { label: 'Low Confidence', tone: 'low' },
    // 3: { label: 'Moderate Confidence', tone: 'moderate' },
    // 4: { label: 'High Confidence', tone: 'high' },
    // 5: { label: 'Very High Confidence', tone: 'very-high' },

/**
 * Normalizes a numeric rating into a descriptive confidence level.
 *
 * @param {number} rawValue
 * @returns {{label: string, tone: string, value: number|null}}
 */
export function getConfidenceLevel(rawValue) {
    if (!Number.isFinite(rawValue)) {
        return {
            label: 'Confidence Unknown',
            tone: 'unknown',
            value: null,
        };
    }

    const clampedValue = Math.min(Math.max(Math.round(rawValue), 1), 5);
    const level = LEVEL_MAP[clampedValue] ?? LEVEL_MAP[3];

    return {
        ...level,
        value: clampedValue,
    };
}
